var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nomination_list_box_container"},_vm._l((_vm.contests),function(contest){return _c('div',{key:contest.id,staticClass:"nomination_list_box"},[_c('nomination-supercat-contest-box',{attrs:{"contest":contest,"list_type":_vm.list_type,"supercat_icon":_vm.supercat_icon}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1760f3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/nominate/nominate_list_box.vue
// module id = 305
// module chunks = 1